/** Pinned at top of country selectors (order preserved); remaining countries A–Z. */
export const PRIORITY_COUNTRIES = [
  'United States of America',
  'United Kingdom',
  'Canada',
  'Germany',
  'Malaysia',
  'Australia',
];

const priorityIndex = new Map(PRIORITY_COUNTRIES.map((name, i) => [name, i]));

const compareCountryNames = (a, b) => {
  const aPri = priorityIndex.has(a) ? priorityIndex.get(a) : Infinity;
  const bPri = priorityIndex.has(b) ? priorityIndex.get(b) : Infinity;
  if (aPri !== bPri) return aPri - bPri;
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
};

/** Sort an array of country name strings. */
export const sortCountryNamesByPriority = (names) =>
  [...(names || [])].sort(compareCountryNames);

/**
 * Sort country objects by priority (uses `country_name` by default).
 * @param {Array<object>} countries
 * @param {string} [nameKey='country_name']
 */
export const sortCountriesByPriority = (countries, nameKey = 'country_name') =>
  [...(countries || [])].sort((a, b) =>
    compareCountryNames(a?.[nameKey] || '', b?.[nameKey] || '')
  );
